export default {
  SET_REGIONS(state, data) {
    state.regions = data
  },
  SET_DISTRICTS(state, data) {
    state.districts = data
  },
  SET_STAGE_TYPES(state, data) {
    state.stage_types = data
  },
  SET_CURRENCIES(state, data) {
    state.currencies = data
  },
  SET_APARTMENT_MATERIALS(state, data) {
    state.apartment_materials = data
  },
  SET_PREMISES_DECORATIONS(state, data) {
    state.premises_decorations = data
  },
  SET_CONSTRUCTION_STAGES(state, data) {
    state.construction_stages = data
  },
  SET_PLANNING_TYPES(state, data) {
    state.planning_types = data
  },
  SET_OUTPUT_WINDOWS(state, data) {
    state.output_windows = data
  },
  SET_QUARTERS(state, data) {
    state.quarters = data
  },
  SET_MONTHS(state, data) {
    state.months = data
  },
  SET_APARTMENT_TYPES(state, data) {
    state.apartment_types = data
  },
  SET_CONTRUCTION_TYPES(state, data) {
    state.contruction_types = data
  },
  SET_FLAT_STATUSES(state, data) {
    state.flat_statuses = data
  },
  SET_FLAT_DECORATIONS(state, data) {
    state.flat_decorations = data
  },
  SET_FLAT_LIVING_AREA_TYPES(state, data) {
    state.flat_living_area_types = data
  },
  SET_FLAT_NONLIVING_AREA_TYPES(state, data) {
    state.flat_nonliving_area_types = data
  },
  SET_OCCUPIED_BY_LIST(state, data) {
    state.occupied_by_list = data
  },
  SET_SALE_OFFICES(state, data) {
    state.sale_offices = data
  },
  SET_CONSTRUCTORS(state, data) {
    state.constructors = data
  },
  SET_PAYMENT_INTERESTS(state, data) {
    state.payment_interests = data
  },
  SET_PAYMENT_METHODS(state, data) {
    state.payment_methods = data
  },
  SET_ONE_CONSTRUCTOR(state, data) {
    state.single_constructor = data
  },
  SET_PROJECT_STAFF(state, data) {
    state.project_staff = data
  },
}
